import React from "react";
import PropTypes from "prop-types";

const SummaryTab = ({ partner }) => {
  if (!partner) return null;

  const jobStats =
    partner?.job_stats ||
    partner?.jobStats ||
    partner?.stats?.jobs ||
    {};

  const earnings =
    partner?.earnings ||
    partner?.earning_stats ||
    partner?.stats?.earnings ||
    {};

  const formatValue = (value) =>
    value === null || value === undefined || value === "" ? "-" : value;

  const formatMoney = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    const num = Number(value);
    if (Number.isFinite(num)) return `₹${num}`;
    return String(value);
  };

  return (
    <div className="space-y-6">
      {/* TOP STATS */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <StatCard title="Total Jobs" value={formatValue(jobStats.total)} />
        <StatCard title="Completed Jobs" value={formatValue(jobStats.completed)} />
        <StatCard title="Pending Jobs" value={formatValue(jobStats.pending)} />
        <StatCard title="Rejected Jobs" value={formatValue(jobStats.rejected)} />
      </div>

      {/* EARNINGS */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <StatCard title="Total Earnings" value={formatMoney(earnings.total)} />
        <StatCard title="Total Payout" value={formatMoney(earnings.paid)} />
        <StatCard title="Pending Amount" value={formatMoney(earnings.pending)} />
      </div>

      {/* PARTNER INFO */}
      <div className="border rounded-lg p-5 bg-gray-50">
        <h3 className="font-semibold mb-4 text-lg">Partner Overview</h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
          <Info label="Name" value={partner.name} />
          <Info label="Mobile" value={partner.mobile} />
          <Info label="Profession" value={partner.profession} />
          <Info label="Service Area" value={partner.service_areas} />
          <Info label="Team Size" value={partner.team_size} />
          <Info label="Status" value={formatValue(partner.status)} />
        </div>
      </div>
    </div>
  );
};

/* SMALL COMPONENTS */

const StatCard = ({ title, value }) => (
  <div className="border rounded-lg p-4 bg-white shadow-sm">
    <p className="text-sm text-gray-500">{title}</p>
    <p className="text-2xl font-bold mt-1">{value}</p>
  </div>
);

const Info = ({ label, value }) => (
  <div>
    <p className="text-gray-500 text-xs">{label}</p>
    <p className="font-medium">{value || "-"}</p>
  </div>
);

/* PROP TYPES */

SummaryTab.propTypes = {
  partner: PropTypes.object.isRequired,
};

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

Info.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default SummaryTab;
